// extracted by mini-css-extract-plugin
module.exports = {"spin-container":"Quizzes_spin-container__3c3T_","container":"Quizzes_container__2AAYl"};